import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sheet from '../ui/Sheet';
import Icon from '../ui/Icon';
import { useAdminShell } from './AdminContext';
import { usePopup } from '../../context/PopupContext';
import { clearAuth, getUser } from '../../utils/authUtil';

const ROLE_LABEL = { super_admin: 'Super Admin', college_admin: 'College Admin', admin: 'College Admin' };

/**
 * Opened by tapping the avatar — the same profile-menu pattern the student shell uses (identity,
 * then account actions), scaled to what an admin actually has: no XP/level, just who they are, then
 * Feedback, Settings (change password) and Logout.
 */
export default function AdminProfileSheet() {
  const navigate = useNavigate();
  const { showConfirm } = usePopup();
  const user = getUser();
  const { isSuper, profileOpen, closeProfile, newFeedbackCount } = useAdminShell();

  const go = (path) => { closeProfile(); navigate(path); };
  const logout = async () => {
    closeProfile();
    const ok = await showConfirm('Log out', 'Are you sure you want to log out of Zaptude?');
    if (ok) { clearAuth(); navigate('/login'); }
  };

  const rows = [
    { key: 'feedback', icon: 'feedback', title: 'Feedback', sub: isSuper ? 'Bug reports and suggestions from your team' : 'Report a bug or suggest an idea', badge: isSuper ? newFeedbackCount : null, onClick: () => go(isSuper ? '/super-admin/feedback' : '/admin/feedback') },
    { key: 'settings', icon: 'settings', title: 'Settings', sub: 'Password and appearance', onClick: () => go('/admin/settings') },
  ];

  return (
    <Sheet open={profileOpen} onClose={closeProfile} label="Your profile menu" hideClose>
      <div className="az-profile-sheet">
        <div className="az-profile-id">
          <span className="az-profile-avatar">{(user?.name || 'A')[0].toUpperCase()}</span>
          <div className="az-profile-id-body">
            <div className="az-profile-name">{user?.name || 'Admin'}</div>
            <div className="az-profile-meta">
              <span className="z-chip z-chip--violet">{ROLE_LABEL[user?.realRole || user?.role] || 'Admin'}</span>
              {user?.collegeName && <span className="az-profile-college">{user.collegeName}</span>}
            </div>
          </div>
        </div>

        <div className="z-list az-profile-list">
          {rows.map(r => (
            <button key={r.key} type="button" className="z-list-row" onClick={r.onClick}>
              <span className="az-profile-row-icon"><Icon name={r.icon} size={20} /></span>
              <span className="z-list-row-body">
                <span className="z-list-row-title">{r.title}</span>
                <span className="z-list-row-sub" style={{ display: 'block' }}>{r.sub}</span>
              </span>
              {r.badge > 0 && <span className="z-chip z-chip--violet">{r.badge}</span>}
              <Icon name="chevron-right" size={18} />
            </button>
          ))}
        </div>

        <button type="button" className="z-list-row z-list-row--danger az-profile-logout" onClick={logout}>
          <span className="az-profile-row-icon az-profile-row-icon--danger"><Icon name="logout" size={20} /></span>
          <span className="z-list-row-body"><span className="z-list-row-title">Log out</span></span>
        </button>
      </div>
    </Sheet>
  );
}
